import React from "react";

const statusBadgeClassMap = {
  pending: "border border-[#FFCA28] bg-[#FFCA2833] text-[#FFCA28]",
  completed: "border border-[#22C55E] bg-[#22C55E1F] text-[#22C55E]",
};

const defaultCourses = [
  {
    id: 1,
    title: "Advanced JavaScript",
    instructor: "David Miller",
    status: "pending",
    progress: 20,
  },
  {
    id: 2,
    title: "Advanced JavaScript",
    instructor: "David Miller",
    status: "completed",
    progress: 20,
  },
  {
    id: 3,
    title: "Advanced JavaScript",
    instructor: "David Miller",
    status: "pending",
    progress: 20,
  },
];

const StudentEnrolledCourses = ({
  courses = defaultCourses,
  onViewDetails,
}) => {
  return (
    <section className="rounded-xl border border-[#60555557] bg-white pt-[22px] pb-14 px-6">
      <h3 className="text-xl font-medium leading-[23px] text-black">Enrolled Courses</h3>

      <div className="mt-6 space-y-[23px]">
        {courses.map((course) => {
          const statusKey = (course.status || "pending").toLowerCase();
          const statusClass =
            statusBadgeClassMap[statusKey] || statusBadgeClassMap.pending;

          return (
            <div key={course.id} className="border border-[#D9D9D9A1] rounded-[7px] px-[18px] py-2.5">
              <div className="flex items-start justify-between gap-3">
                <div>
                  <p className="text-[22px] font-medium leading-[26px] text-black">
                    {course.title}
                  </p>
                  <p className="mt-1 text-[19px] leading-[22px] text-[#595959]">
                    Instructor: {course.instructor}
                  </p>
                </div>
                <span
                  className={`shrink-0 rounded-full px-2 py-[3px] text-xs leading-[14px]  capitalize ${statusClass}`}
                >
                  {course.status}
                </span>
              </div>

              <div className="mt-3 flex items-center justify-between leading-[21px] text-lg text-black">
                <span className="font-medium">Course Progress</span>
                <span className="font-medium">{course.progress}%</span>
              </div>

              <div className="mt-3 h-[13px] w-full rounded-[5px] bg-[#D2D2D2]">
                <div
                  className="h-[13px] rounded-[5px] bg-[#923D8C]"
                  style={{ width: `${course.progress}%` }}
                />
              </div>

              <div className="mt-[11px] h-[19px]">
                <button
                  type="button"
                  className="leading-[19px] text-base   text-[#923D8C]"
                  onClick={() => onViewDetails?.(course)}
                >
                  View Details
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default StudentEnrolledCourses;
